import React, { useState } from 'react';

const SponsorshipForm = ({ currentUser, onSubmit }) => {
  const [formData, setFormData] = useState({
    filleulEmail: '',
    requestedLevel: 'adherent_sympathisant'
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const getHelpText = (level) => {
    switch (level) {
      case 'adherent_actif':
        return 'Nécessite 3 parrains Actifs ou 1 Membre Fondateur';
      case 'adherent_participant':
        return 'Nécessite 3 parrains Participants ou 1 Membre Fondateur';
      case 'adherent_sympathisant':
        return 'Nécessite 2 parrains Sympathisants ou 1 Membre Fondateur';
      case 'membre_fondateur':
        return 'Nécessite 1 seul parrain Membre Fondateur';
      default:
        return '';
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);

    try {
      const response = await fetch('/api/v1/sponsorships', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': document.querySelector('[name="csrf-token"]').content
        },
        body: JSON.stringify({
          sponsorship: {
            filleul_email: formData.filleulEmail,
            requested_level: formData.requestedLevel
          }
        })
      });

      const data = await response.json();

      if (response.ok) {
        onSubmit(data.data.sponsorship);
      } else {
        setError(data.message || 'Une erreur est survenue');
      }
    } catch (err) {
      setError('Erreur de connexion. Veuillez réessayer.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      {error && (
        <div className="alert alert-danger" role="alert" style={{ borderRadius: 14, border: '1px solid rgba(220,38,38,0.18)' }}>
          {error}
        </div>
      )}

      <div className="mb-4">
        <label htmlFor="filleulEmail" className="form-label" style={{ color: '#7a4050', fontWeight: 600 }}>
          Email du Filleul *
        </label>
        <input
          type="email"
          className="form-control"
          id="filleulEmail"
          name="filleulEmail"
          value={formData.filleulEmail}
          onChange={handleInputChange}
          placeholder="filleul@example.com"
          style={{ borderRadius: 14, borderColor: 'rgba(124,40,55,0.18)', padding: '14px 16px', boxShadow: 'none' }}
          required
        />
      </div>

      <div className="mb-4">
        <label htmlFor="requestedLevel" className="form-label" style={{ color: '#7a4050', fontWeight: 600 }}>
          Niveau Demandé *
        </label>
        <select
          className="form-select"
          id="requestedLevel"
          name="requestedLevel"
          value={formData.requestedLevel}
          onChange={handleInputChange}
          style={{ borderRadius: 14, borderColor: 'rgba(124,40,55,0.18)', padding: '14px 16px', boxShadow: 'none' }}
          required
        >
          <option value="adherent_sympathisant">Adhérent Sympathisant</option>
          <option value="adherent_participant">Adhérent Participant</option>
          <option value="adherent_actif">Adhérent Actif</option>
          {currentUser?.level === 'membre_fondateur' && (
            <option value="membre_fondateur">Membre Fondateur</option>
          )}
        </select>
        <div className="form-text" style={{ color: '#9e6575' }}>
          {getHelpText(formData.requestedLevel)}
        </div>
      </div>

      <div className="d-grid">
        <button
          type="submit"
          className="btn"
          style={{ background: 'linear-gradient(135deg,#7c2837,#a8384e)', color: '#fff', border: 'none', borderRadius: 14, padding: '14px 18px', fontWeight: 700 }}
          disabled={loading}
        >
          {loading ? 'Création en cours...' : 'Créer la Demande'}
        </button>
      </div>
    </form>
  );
};

export default SponsorshipForm;